import React from "react";
import NavigationBar from "../../components/navigation/desktop/NavigationBar";
import MobileNavigationBar from "../../components/navigation/mobile/MobileNavigationBar";
import PageFooter from "./PageFooter";
import { SeasonProvider } from "../../components/seasonal/SeasonContext";
import SeasonalTheme from "../../components/seasonal/SeasonalTheme";
import { SeasonType } from "../../components/seasonal/seasonConfig";

type Parameters = {
    children : any;
    particleDuration?: number; // Duration in seconds (0 = infinite)
    overrideSeason?: SeasonType; // For testing different seasons
}

const PageLayout = ({ children, particleDuration = 0, overrideSeason }: Parameters) => {
    return (
        <SeasonProvider overrideSeason={overrideSeason}>
            <div className="page-layout">
                <SeasonalTheme particleDuration={particleDuration} />
                <NavigationBar />
                <MobileNavigationBar />
                <div className="page-layout__content">{children}</div>
                <PageFooter />
            </div>
        </SeasonProvider>
    );
};

export default PageLayout;